import faker from 'faker'
import label from 'src/../config/label'

export const mocker = {
  currentUser () {
    return {
      status: 1,
      p_coduser: faker.lorem.word(),
      p_codpswd: faker.lorem.sentence(),
      p_codempid: faker.address.zipCode(),
      username: {
        en: faker.lorem.word(),
        th: faker.lorem.word()
      },
      p_codpos: Math.floor((Math.random() * 4) + 1),
      position: {
        en: faker.lorem.word(),
        th: faker.lorem.word()
      },
      p_codcomp: Math.floor((Math.random() * 4) + 1),
      company: {
        en: faker.lorem.word(),
        th: faker.lorem.word()
      },
      usrcom: {
        0: faker.lorem.word()
      },
      p_lrunning: Math.floor((Math.random() * 2) + 1),
      path_hrtrele: '',
      path_hrrcote: '',
      path_hrrcbne: '',
      googlemaps_api_key: ''
    }
  },
  signout () {
    return {
      status: 'SUCCESS',
      data: {
        status: '200',
        message: 'logout success'
      }
    }
  },
  baseConn () {
    return label.baseConn
  },
  forgetPassword () {
    return {
      status: 'ERROR',
      data: {
        status: '',
        message: 'ERROR While Process, Please Refresh page then process again.'
      }
    }
  },
  verifyotp () {
    return {
      status: 'success',
      redirect: ''
    }
  },
  changePassword () {
    return {
      status: 'ERROR',
      data: {
        status: '',
        message: 'ERROR While Process, Please Refresh page then process again.'
      }
    }
  },
  authVueMiddleware () {
    return {
      status: 'SUCCESS',
      redirect: ''
      // status: 'LICENSE',
      // redirect: 'home'
      // status: 'TIMEOUT',
      // redirect: 'login'
      // status: 'ERROR',
      // redirect: 'login'
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/login/mocker.js